module.exports = __webpack_public_path__ + "static/visionar_case_study_ar-for-product-packaging-400x284-10cdb97845deaf3c0fb2cebcef5ec948.png";